/* eslint-disable import/no-cycle */
import { ROOT_SLICE } from './constants';
import { selectRootSlice } from './selectors';
import { setDevFeaturesEnabled, setShowDisabledUsers } from './actions';

// ************
// PARTS
// ************
const reducerParts = {
	[setDevFeaturesEnabled]: (state, { payload: { enable } }) => {
		const rootSlice = selectRootSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, devFeaturesEnabled: enable }
		};
	},
	[setShowDisabledUsers]: (state, { payload: { show } }) => {
		const rootSlice = selectRootSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...rootSlice, showDisabledUsers: show }
		};
	},
};

export default reducerParts;
